export type TeamMember = {
  userId: string;
  teamId: string;
  id: string;
} & Permissions;

export type TeamSettings = {
  name: string;
  id: string;
  canAccessStocks: boolean;
  canAccessClients: boolean;
  canAccessVisits: boolean;
};

export const DEFAULT_USERS_TEAM = 'users-team';
export const DEFAULT_STOCK = 'default-stock';

export type Permissions = {
  canAccessStocks: boolean;
  canAccessClients: boolean;
  canAccessVisits: boolean;
};

export type TeamMemberRow = TeamSettings & { userId: string };

export const transformTeamMembersToRows = (
  teamMembers: (TeamMember & { user: { name: string } })[],
): TeamMemberRow[] => {
  return teamMembers.map(member => ({
    id: member.id,
    userId: member.userId,
    name: member.user.name,
    canAccessStocks: member.canAccessStocks,
    canAccessClients: member.canAccessClients,
    canAccessVisits: member.canAccessVisits,
  }));
};
